import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// --- PLACEHOLDER FIREBASE CONFIGURATION ---
// Replace this with the config object from your Firebase Console
const firebaseConfig = {
    apiKey: "AIzaSyB2VgG-TP9eHHwAA-xqLqJZmbJfq05nvP4",
    authDomain: "health-card-a9b9a.firebaseapp.com",
    projectId: "health-card-a9b9a",
    storageBucket: "health-card-a9b9a.firebasestorage.app",
    messagingSenderId: "274106233888",
    appId: "1:274106233888:web:af6125a40d12771d44b845",
    measurementId: "G-81NJ7DC24E"
};
// ------------------------------------------

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
export const messaging = typeof window !== 'undefined' ? getMessaging(app) : null;

export const requestFirebaseNotificationPermission = async () => {
    try {
        if (!messaging) return null;

        console.log('Requesting permission...');
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            console.log('Notification permission granted.');
            // Get the token
            // NOTE: Replace 'YOUR_VAPID_KEY' with the key generated in the Firebase Console -> Cloud Messaging settings
            const token = await getToken(messaging, { vapidKey: 'BPNFgEDminRPqzradxDXWM_7Z9CT8aLWIyOLkbghPtmqExbb-TL13hbnAv-GmuuOFBfTZJbeKFlbfkEzTnY87Hw' });
            if (token) {
                console.log('FCM Token:', token);
                return token;
            } else {
                console.log('No registration token available. Request permission to generate one.');
                return null;
            }
        } else {
            console.log('Do not have permission!');
            return null;
        }
    } catch (error) {
        console.error('An error occurred while retrieving token. ', error);
        return null;
    }
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        if (!messaging) return;
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
